<template>
	<div>
		<div class="actDiv">
			<label>告警类型</label>
			<a-select  style="width:10rem; margin: 0 0.625rem; font-size: 0.6875rem;" v-model="theAlarm" placeholder="选择告警类型" allowClear label-in-value>
				<a-select-option v-for="(item,index) in alarmTypeList" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
			</a-select>
			<label>表地址</label>
			<a-input placeholder="水表地址" v-model="paramModel.meterAddr" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<label>给水号</label>
			<a-input placeholder="给水号" v-model="paramModel.apId" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<label>册本号</label>
			<a-input placeholder="册本号,支持模糊查询" v-model="paramModel.bookNum" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<a-button  size="small"  icon="search" @click="doQuery">查找</a-button>
			<a-button  size="small"  icon="download" @click="exportIt" style="margin-left: 0.425rem;" :loading="exportLoading">导出</a-button>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="500"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="id">
			<vxe-table-column title="所属小区" field="neighborId"    :formatter="getTheNeighborName"></vxe-table-column>
			<vxe-table-column title="给水号" field="apId"></vxe-table-column>
			<vxe-table-column title="册本号" field="bookNum"></vxe-table-column>
			<vxe-table-column title="水表地址" field="meterAddr"></vxe-table-column>
			<vxe-table-column title="告警类型" field="alarmType" :formatter="getTheAlarmName"></vxe-table-column>
			<vxe-table-column title="告警内容" field="alarmContent" ></vxe-table-column>
			<vxe-table-column title="告警时间" field="createTime" ></vxe-table-column>
			<vxe-table-column title="操作" field="PID" width="200">
				<template #default="{ row }">
					<a-button   size="small"  type="link"  @click="showHistoryData(row)">历史读数</a-button>
				</template>
			</vxe-table-column>
		</vxe-table>					
		<div style="float: right; margin-top: 1rem;" >
			<a-pagination :current="paramModel.pageNum"  showQuickJumper :show-total="total => `共 ${total} 条`"
				 :pageSize="paramModel.pageSize" :total="paramModel.totalRecords" @change="pageChangeHandler"/>
		</div>
		<a-drawer title="历史读数"  :visible="showHistoryFlag" width="520" @close="showHistoryFlag = false" :destroyOnClose="true"  :maskClosable="true">
			<MeterReadHistory  :theId="theObj.meterId"/>
		</a-drawer>
	</div>
</template>

<script>
	import MeterReadHistory from '../components/MeterReadHistory.vue' 
	export default {
		components:{
			MeterReadHistory,
		},
		data() {
			return {
				dataList:[],
				neighborList: [],
				theAlarm:undefined,
				paramModel:{
					alarmType:null,
					meterAddr:null,
					apId:null,
					pageNum: 1,
					pageSize: 10,
					totalRecords:0,
					bookNum:null,
				},
				loading:false,
				showHistoryFlag:false,
				theObj:{},
				exportLoading:false,
			}
		},
		methods: {
			exportIt(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.EXPORT_ALARM_DATA_URL);
				let param = this.getParam();
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '异常告警.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			doQuery(){
				this.paramModel.pageNum = 1;
				this.paramModel.pageSize  = 10;
				this.queryData();
			},
			showHistoryData(item){
				this.theObj = this.Config.deepClone(item);
				this.showHistoryFlag = true;
			},
			pageChangeHandler(pageNo,pageSize){
				this.paramModel.pageNum = pageNo;
				this.paramModel.pageSize = pageSize;
				this.queryData();
				
			},
			queryData(){
				this.loading = true;
				let param = this.getParam();
				let url = this.Api.getLastUrl(this.Api.QUERY_METER_ALARM_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result.content;
						this.paramModel.totalRecords = result.recordTotal;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getParam(){
				if(this.theAlarm!=undefined){
					this.paramModel.alarmType = this.theAlarm.key;
				}
				return this.paramModel;
			},
			getTheNeighborName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(cellValue == item.pId){
						result = item.neighborName;
						break;
					}
				}
				return result;
			},
			getTheAlarmName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.alarmTypeList.length;i++){
					let item = this.alarmTypeList[i];
					if(cellValue == item.value){
						result = item.name;
						break;
					}
				}
				return result;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryNeighbors:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
						this.queryData();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created(){
			this.queryNeighbors();
		},
		computed: {
			alarmTypeList(){
				return  this.Config.getAlarmTypeList();
			},
			check4Wh:function(){
				let user = this.Config.getUserLocal();
				if(user.wcId == 37){
					return true;
				}else{
					return false;
				}
			},
		},
	}
</script>

<style>
</style>
